import { arrayContainsValues } from '@shared/core/types/common';

const googleAllowedCardAuthMethod: google.payments.api.allowedCardAuthMethods = [
    'PAN_ONLY', 'CRYPTOGRAM_3DS'
];

export const googleAllowedCardAuthMethodType = arrayContainsValues(...googleAllowedCardAuthMethod);
